var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sidebar-item',{attrs:{"link":{
            name: 'Painel de notificações',
            icon: 'tim-icons icon-bell-55',
            path: {name: 'finance_manager.finance.panel_notification'}
          },"notify":_vm.panel_notifications.length}}),(_vm.$hasRole(_vm.role.FINANCE_MANAGER.value))?_c('sidebar-item',{attrs:{"material":true,"link":{
          name: 'Tomadores/Documentação',
          icon: 'group',
          path: {name: 'finance_manager.finance.takers'}
        }}}):_vm._e(),(_vm.$canAny([_vm.permission.FINANCE__ADMIN.value])
            && _vm.$hasRole(_vm.role.FINANCE_MANAGER.value))?_c('sidebar-item',{attrs:{"material":true,"link":{
          name: 'Instituição Financeira',
          icon: 'business',
          path: {name: 'finance_manager.fintech'}
        }}}):_vm._e(),(_vm.$canAny([_vm.permission.FINANCE__ADMIN.value])
            && _vm.$hasRole(_vm.role.FINANCE_MANAGER.value))?_c('sidebar-item',{attrs:{"material":true,"link":{
          name: 'Usuarios',
          icon: 'groups',
          path: {name: 'finance_manager.finance.users'}
        }}}):_vm._e(),(_vm.$canAny([_vm.permission.FINANCE__ADMIN.value])
            && _vm.$hasRole(_vm.role.FINANCE_MANAGER.value))?_c('sidebar-item',{attrs:{"link":{
          name: 'Configuração',
          icon: 'tim-icons icon-settings-gear-63',
          path: {name: 'finance_manager.finance.attachments'}
        }}}):_vm._e(),(_vm.$hasRole(_vm.role.FINANCE_MANAGER.value))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.quotes'),
          icon: 'tim-icons icon-paper',
          path: {name: 'finance_manager.finance'}
        }}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }